import { setRegisteredData } from "./registered-data";

$('.winner-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    setRegisteredData(data, 'section#winner');

    // page swap
    $('section#winner .page').addClass('d-none');
    $('section#winner .page-thank-you').removeClass('d-none').css('display', 'block');

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-winner').modal('show');
});

$('.winner-form').on('submit-error', function(event, xhr) {
    event.preventDefault();
    if (xhr.status == 410) {
        alert('Formularz wygasł.');
    }
});

// Regulamin §5.6: laureat Nagród I–III bez numeru PESEL podaje zamiast niego obywatelstwo
// i adres zamieszkania. Adres korespondencyjny (street/streetNr/flatNr/zipCode/city) jest
// wymagany zawsze — nie zależy od PESEL-u.
// Wiersze chowamy i JEDNOCZEŚNIE wyłączamy (`disabled` na <fieldset class="form-group">):
// samo ukrycie zostawiłoby ukryte pole `required`, które blokuje wysyłkę formularza.
// Serwer robi to samo przez `_enabled_if` w config/packages/workflow.yaml.
$('[name="personal_data[noPesel]"]').on('change', function() {
    const noPesel = $(this).prop('checked');
    const toggle = (selector, visible) => $(selector, this.form)
        .closest('.form-group')
        .toggleClass('d-none', !visible)
        .prop('disabled', !visible);

    toggle('[name="personal_data[pesel]"]', !noPesel);
    toggle('[name="personal_data[citizenship]"], [name="personal_data[residenceAddress]"]', noPesel);
}).trigger('change');